import { DynamicAssetsKeys, DynamicAsset, DynamicAssets } from './models';
const publicResources = require(`./resources/${globals.REACT_APP_PARTNER}`).default;

export { DynamicAsset, DynamicAssets, DynamicAssetsKeys } from './models';

// Assigning to const allows this to be preserved per story in storybook
const PARTNER_CODE = globals.REACT_APP_PARTNER;

const assets: DynamicAssets = require(`./${PARTNER_CODE}.tsx`).default;

export default function getPartnerAsset<T extends DynamicAsset>(identifier: DynamicAssetsKeys): T {
  return <T>assets[identifier];
}

export function getPartnerResource(fileName: string): string {
  return require(`./resources/${PARTNER_CODE}/${fileName}`);
}

export function getPublicPartnerResource(resourceName: string): string {
  return publicResources[resourceName];
}



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/index.ts